/* eslint-disable react-hooks/exhaustive-deps */
import { Table, Button, Modal } from "antd";
import axios from "axios";
import dayjs from "dayjs";
import parse from "html-react-parser";
import { useEffect, useState } from "react";

import {
  showWarningNotification,
  showErrorNotification,
  showSuccessNotification
} from "../../../../utils/notification";
import { clamp } from "../../../../utils/responsiveHelpers";

const DiscussionMessagesModal = ({
  problemId,
  ROOT_URL,
  isModalOpen = false,
  setIsModalOpen = () => {}
}) => {
  const [discussionMessages, setDiscussionMessages] = useState([]);

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleFetchDiscussionMessages = (problemId) => {
    axios
      .get(`${ROOT_URL}/admin/cp-sheet/problems/discussion/fetch-messages`, {
        params: {
          problemId
        }
      })
      .then((res) => {
        const { discussions } = res.data;
        setDiscussionMessages(discussions);
        showSuccessNotification("Discussions fetched successfully");
      })
      .catch((err) => {
        showErrorNotification(err);
      });
  };

  const handleDeleteDiscussionMessage = (messageId) => {
    axios
      .post(`${ROOT_URL}/admin/cp-sheet/problems/discussion/delete-message`, {
        messageId
      })
      .then(() => {
        handleFetchDiscussionMessages(problemId);
      })
      .catch((err) => {
        showErrorNotification(err);
      });
  };

  const discussionMessagesColumns = [
    {
      title: "S No.",
      dataIndex: "index",
      key: "index"
    },
    {
      title: "User Name",
      dataIndex: "userName",
      key: "userName"
    },
    {
      title: "Content",
      dataIndex: "content",
      key: "content",
      render: (content) => parse(content)
    },
    {
      title: "Replies Count",
      dataIndex: "repliesCount",
      key: "repliesCount",
      sorter: (a, b) => a["repliesCount"] - b["repliesCount"]
    },
    {
      title: "Likes Count",
      dataIndex: "likesCount",
      key: "likesCount",
      sorter: (a, b) => a["likesCount"] - b["likesCount"]
    },
    {
      title: "Is Parent Message",
      dataIndex: "isParentMessage",
      key: "isParentMessage",
      render: (isParentMessage) => (isParentMessage ? "Yes" : "No")
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (createdAt) => (createdAt ? dayjs(createdAt).format("DD MMM YYYY | hh:mm") : "--")
    },
    {
      title: "Actions",
      key: "action",
      width: 50,
      render: (row) => (
        <div
          id="cp_sheet_problem_discussion_messages"
          style={{
            display: "flex",
            justifyContent: "space-around",
            gap: "5px"
          }}
        >
          <>
            <Button
              type="primary"
              danger
              onClick={() => {
                if (row.isParentMessage) {
                  showWarningNotification("This will delete all the child messages as well.");
                }
                handleDeleteDiscussionMessage(row.key);
              }}
            >
              Delete Message
            </Button>
          </>
        </div>
      )
    }
  ];

  useEffect(() => {
    handleFetchDiscussionMessages(problemId);
  }, [problemId]);

  return (
    <Modal
      title="Discussion Messages"
      open={isModalOpen}
      footer={[]}
      width={2500}
      onOk={handleOk}
      onCancel={handleCancel}
    >
      <div
        style={{
          marginTop: "20px",
          marginLeft: clamp(12, 30),
          marginRight: clamp(12, 30)
        }}
      >
        <br />
        <h2>Deleting any parent message will delete all the child messages too</h2>
        <Table
          columns={discussionMessagesColumns}
          dataSource={discussionMessages}
          bordered
          pagination={false}
          scroll={{ x: 500 }}
        />
      </div>
    </Modal>
  );
};

export default DiscussionMessagesModal;
